/* Better Root theme — one small, dependency-free script (~10 KB). */
(() => {
  'use strict';
  const BR = window.BR || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || BR.moneyFormat || 'Rs.{{amount_no_decimals}}';
    const fmt = (n, d, ts = ',', ds = '.') => {
      const fixed = (n / 100).toFixed(d);
      const [i, f] = fixed.split('.');
      return Number(i).toLocaleString('en-US').split(',').join(ts) + (f && Number(f) > 0 ? ds + f : '');
    };
    return format.replace(new RegExp('[{][{][ ]*([a-z_]+)[ ]*[}][}]'), (_, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 0);
      }
    }).replace(/<[^>]*>/g, '');
  }
  BR.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers (menu + cart) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      const f = $('[data-autofocus], button, a, input', el.querySelector('[role="dialog"]') || el);
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
    });
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 420);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.getAttribute('data-open'));
      if (target) { e.preventDefault(); openDrawer(target); opener.setAttribute('aria-expanded', 'true'); }
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      const d = closer.closest('.drawer, .menu-drawer');
      if (d) { e.preventDefault(); closeDrawer(d); $$(`[data-open="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false')); }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .menu-drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Announcement rotation (mobile) ---------- */
  $$('[data-announce]').forEach((bar) => {
    const items = $$('.announce__item', bar);
    if (items.length < 2) { items[0] && items[0].classList.add('is-active'); return; }
    let i = 0;
    items[0].classList.add('is-active');
    if (reduceMotion) return;
    setInterval(() => {
      if (window.innerWidth >= 990) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- Reveal on scroll ---------- */
  const revealEls = $$('.reveal, .leafgrow');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Delivery dates ---------- */
  function addWorkingDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!(BR.skipSundays && d.getDay() === 0)) added++;
    }
    return d;
  }
  function fmtDay(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  $$('[data-delivery-range]').forEach((el) => {
    const now = new Date();
    const a = addWorkingDays(now, Number(BR.deliveryMin) || 3);
    const b = addWorkingDays(now, Number(BR.deliveryMax) || 5);
    el.textContent = `${fmtDay(a)} – ${fmtDay(b)}`;
  });

  /* ---------- Cart ---------- */
  const cartDrawer = () => document.getElementById('CartDrawer');

  async function refreshCart(open) {
    try {
      const res = await fetch(`${BR.routes.root}?sections=cart-drawer`.replace('//?', '/?'), { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-inner]');
        // Read the item count before the fresh markup is moved into the page.
        const countEl = doc.querySelector('[data-cart-count-source]');
        const count = countEl ? countEl.getAttribute('data-cart-count-source') : null;
        const cur = $('[data-cart-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
        if (count !== null) updateCount(count);
      }
      if (open) openDrawer(cartDrawer());
    } catch (err) {
      if (open) window.location.href = BR.routes.cart;
    }
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = Number(n) > 0 ? n : ''; el.setAttribute('data-count', n); });
  }

  async function addToCart(items, button) {
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(`${BR.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || BR.strings.error);
      document.dispatchEvent(new CustomEvent('br:cart-added', { detail: { items } }));
      if (BR.cartAction === 'checkout') { window.location.href = '/checkout'; return; }
      await refreshCart(true);
    } catch (err) {
      toast(err.message || BR.strings.error);
    } finally {
      if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-quick-add], [data-product-form]')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') || 1);
    if (!id) return;
    const btn = e.submitter || $('[type="submit"]', form);
    const items = [{ id, quantity }];
    fd.getAll('pair').map(Number).filter((pid) => pid && pid !== id).forEach((pid) => items.push({ id: pid, quantity: 1 }));
    addToCart(items, btn);
  });

  async function changeLine(line, quantity) {
    const inner = $('[data-cart-inner]');
    if (inner) inner.classList.add('is-busy');
    try {
      const res = await fetch(`${BR.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.description || BR.strings.error); }
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCart(false);
    } catch (err) {
      toast(err.message || BR.strings.error);
      if (inner) inner.classList.remove('is-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (btn) {
      e.preventDefault();
      const line = Number(btn.getAttribute('data-line'));
      const q = Number(btn.getAttribute('data-qty-change'));
      changeLine(line, Math.max(0, q));
      return;
    }
    const cartLink = e.target.closest('[data-cart-toggle]');
    if (cartLink && cartDrawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer(cartDrawer());
    }
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const form = $('[data-product-form]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const variants = JSON.parse(($('[data-variants]', root) || {}).textContent || '[]');
    const servings = Number(root.getAttribute('data-servings')) || 0;
    const threshold = Number(BR.freeShippingThreshold) || 0;
    const fee = Number(BR.shippingFee) || 0;

    /* Gallery */
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    const counter = $('[data-gallery-count]', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    let current = 0;
    function setCurrent(i) {
      current = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      const active = thumbs[i];
      if (active && active.parentElement) {
        const p = active.parentElement;
        const left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (track) {
      let t;
      track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setCurrent(i);
        }, 60);
      }, { passive: true });
      thumbs.forEach((th, i) => th.addEventListener('click', () => goTo(i)));
      const prev = $('[data-gallery-prev]', root);
      const next = $('[data-gallery-next]', root);
      prev && prev.addEventListener('click', () => goTo(Math.max(0, current - 1)));
      next && next.addEventListener('click', () => goTo(Math.min(slides.length - 1, current + 1)));
      setCurrent(0);
    }

    /* Pack selector */
    const radios = $$('input[name="pack"]', root);
    const ctaPrice = $$('[data-cta-price]', root);
    const payTotal = $('[data-pay-total]', root);
    const payNote = $('[data-pay-note]', root);
    const stickyMeta = $('[data-sticky-meta]');
    const priceBlock = $('[data-price-block]', root);

    /* "Pairs well with": ticked blends go into the same order as the main pack. */
    const pairs = $$('input[name="pair"]', root);
    let currentV = null;
    function updateTotals() {
      const v = currentV;
      pairs.forEach((p) => { const label = p.closest('.pair'); if (label) label.classList.toggle('is-on', p.checked); });
      if (!v) return;
      const picked = pairs.filter((p) => p.checked);
      const order = v.price + picked.reduce((s, p) => s + (Number(p.getAttribute('data-pair-price')) || 0), 0);
      const freeDelivery = threshold > 0 && order >= threshold;
      const total = order + (freeDelivery ? 0 : fee);
      ctaPrice.forEach((el) => { el.textContent = formatMoney(order); });
      if (payTotal) payTotal.textContent = formatMoney(total);
      if (payNote) payNote.textContent = freeDelivery
        ? payNote.getAttribute('data-free')
        : payNote.getAttribute('data-fee').replace('[fee]', formatMoney(fee));
      if (stickyMeta) stickyMeta.innerHTML = `${v.label}${picked.length ? ` + ${picked.length} more` : ''} · <b>${formatMoney(order)}</b>`;
      pairs.forEach((p) => {
        const label = p.closest('.pair');
        const hint = label && $('[data-pair-hint]', label);
        if (hint) hint.hidden = p.checked || freeDelivery || !(threshold > 0 && order + (Number(p.getAttribute('data-pair-price')) || 0) >= threshold);
      });
    }
    pairs.forEach((p) => p.addEventListener('change', updateTotals));
    document.addEventListener('br:cart-added', () => {
      if (!pairs.some((p) => p.checked)) return;
      pairs.forEach((p) => { p.checked = false; });
      updateTotals();
    });

    function selectVariant(id) {
      const v = variants.find((x) => x.id === id);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      currentV = v;
      updateTotals();
      if (priceBlock) {
        const now = $('.price__now', priceBlock);
        const was = $('.price__was', priceBlock);
        if (now) now.textContent = formatMoney(v.price);
        if (was) was.lastChild.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
      }
      const buttons = $$('[data-atc]', root).concat($$('[data-sticky-atc-btn]'));
      buttons.forEach((b) => { b.disabled = !v.available; });
      if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    /* When a shopper picks a pack, show its photo (2 packs / 3 packs), or the main photo for 1 pack. */
    function showPackPhoto(id) {
      const v = variants.find((x) => x.id === id);
      if (!v || !track || !slides.length) return;
      if (!slides.some((s) => s.hasAttribute('data-pack'))) return;
      const i = v.packs > 1 ? slides.findIndex((s) => s.getAttribute('data-pack') === String(v.packs)) : 0;
      if (i >= 0) goTo(i);
    }
    radios.forEach((r) => r.addEventListener('change', () => {
      selectVariant(Number(r.value));
      showPackPhoto(Number(r.value));
    }));
    const checked = radios.find((r) => r.checked);
    if (checked) selectVariant(Number(checked.value));
    if (!currentV && idInput) { currentV = variants.find((x) => x.id === Number(idInput.value)) || null; updateTotals(); }

    /* Sticky add-to-cart */
    const sticky = $('[data-sticky-atc]');
    const mainCta = $('[data-atc]', root);
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      // Show the Order bar whenever the main Order button is off screen (before it or after it),
      // so shoppers can order from the first second without scrolling.
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(mainCta);
      const sBtn = $('[data-sticky-atc-btn]', sticky);
      sBtn && sBtn.addEventListener('click', () => { if (form) form.requestSubmit ? form.requestSubmit(mainCta) : mainCta.click(); });
    }
  });

  /* ---------- Cart: upgrade a line to a bigger pack ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-swap-line]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-loading');
    const inner = $('[data-cart-inner]');
    if (inner) inner.classList.add('is-busy');
    try {
      const res = await fetch(`${BR.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.getAttribute('data-swap-line')), quantity: 0 })
      });
      if (!res.ok) throw new Error(BR.strings.error);
      await addToCart([{ id: Number(b.getAttribute('data-swap-to')), quantity: 1 }], null);
    } catch (err) { toast(err.message || BR.strings.error); b.classList.remove('is-loading'); if (inner) inner.classList.remove('is-busy'); }
  });

  /* ---------- Variant-less "add set" buttons (cross-sell trio) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-set]');
    if (!b) return;
    e.preventDefault();
    const ids = (b.getAttribute('data-add-set') || '').split(',').map(Number).filter(Boolean);
    if (ids.length) addToCart(ids.map((id) => ({ id, quantity: 1 })), b);
  });

  /* Keep cart count fresh after back/forward cache restores */
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(false); });
})();